module.exports = __webpack_public_path__ + "static/media/unionMaster.9d76e49b.svg";